import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { PrizeMiniEntity } from '../../domain/entities/PrizeMiniEntity'

export class PrizeMiniModel extends PrizeMiniEntity {
  prizeId?: number
  prizeType?: string
  prizeCreatedAt?: string
  constructor(dataDto: PrizeMiniModel) {
    super()
    mapEntityProperties<PrizeMiniEntity>(this, dataDto, {
      map: {
        id: dataDto.prizeId ?? dataDto.id,
        type: dataDto.prizeType ?? dataDto.type,
        createdAt: dataDto.prizeCreatedAt ?? dataDto.createdAt
      }
    })
  }
}
